import { useContext } from "react";
import { UserContext } from "../../user/userContext";
import { useIsEmailVerified } from "../../user/token";
import { CommentRestrictedVerifyEmail } from "./CommentRestrictedVerifyEmail";
import CommentTextareaWrapper from "./CommentTextareaWrapper";

const CreateComment = ({ className }) => {
  const user = useContext(UserContext);
  const isEmailVerified = useIsEmailVerified();

  if (!user) {
    return null;
  }

  if (!isEmailVerified) {
    return <CommentRestrictedVerifyEmail />
  }

  return <CommentTextareaWrapper className={className} />
};

export default CreateComment;
